import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import
  SummaryShareCommittedComponent
from '../../../components/purchase-dashboard/group-summary/summary-share.committed';
import {
  showEditCommitModal,
  showWithdrawModal,
  SHARED_NAMESPACE,
} from '../../../actions';
import {
  getCurrentUserMembership,
  getCurrentPurchase,
} from '../../../selectors/purchase-selector';
import Purchase from './../../../lib/purchase';

class SummaryShareCommitted extends Component {
  constructor(props) {
    super(props);
    this.onCommit = this.onCommit.bind(this);
    this.onWithdraw = this.onWithdraw.bind(this);
  }

  onCommit() {
    this.props.showEditCommitModal();
  }

  onWithdraw() {
    this.props.showWithdrawModal();
  }

  render() {
    const {
      membership,
      splitType,
      currentProductCostAmount,
      waitingToComplete,
      chargeDate,
      isMultiPayment,
      costRange,
      nextChargeAmount,
      anyPaymentsAuthorizing,
    } = this.props;

    return (
      <SummaryShareCommittedComponent
        membership={membership}
        splitType={splitType}
        currentProductCostAmount={currentProductCostAmount}
        waitingToComplete={waitingToComplete}
        chargeDate={chargeDate}
        isMultiPayment={isMultiPayment}
        costRange={costRange}
        nextChargeAmount={nextChargeAmount}
        anyPaymentsAuthorizing={anyPaymentsAuthorizing}
        onCommit={this.onCommit}
        onWithdraw={this.onWithdraw}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { memberships } = state;
  const purchase = getCurrentPurchase(state);
  const membership = getCurrentUserMembership(state);
  const projectedMembership = get(state.projections,
    `${SHARED_NAMESPACE}.memberships.${memberships.current}`, {});
  const nextChargeAmount = projectedMembership && projectedMembership.amount;

  return {
    membership,
    nextChargeAmount,
    anyPaymentsAuthorizing: purchase ? Purchase.hasPaymentsAuthorizing(purchase) : false,
    splitType: purchase.group.splitType,
    currentProductCostAmount: purchase.currentProductCostAmount,
    withdraw: true,
    waitingToComplete: Purchase.isWaitingForMerchantToComplete(purchase),
    chargeDate: purchase.nextPaymentDueDeadline,
    isMultiPayment: Purchase.isMultiPayment(purchase.payments),
    costRange: purchase.costRange,
  };
};

const mapDispatchToProps = {
  showEditCommitModal,
  showWithdrawModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryShareCommitted);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/group-summary/summary-share-committed.container.js